import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { BoardContainer } from "./BoardContainer";
import * as Templok from "@ravalmatic/templok-engine";

export class Background extends Phaser.GameObjects.Container {

    private fishesData: {sprite: Phaser.GameObjects.Sprite, y: number, a: number, v: number, dA: number, sign: number} [];
    private storedFishes: {sprite: Phaser.GameObjects.Sprite, y: number, a: number, v: number, dA: number, sign: number}[];

    private fishesContainer: Phaser.GameObjects.Container;

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        this.x = GameConstants.GAME_WIDTH / 2;
        this.y = GameConstants.GAME_HEIGHT * .45;

        this.scaleY = GameVars.scaleY;

        const background = new Phaser.GameObjects.Image(this.scene, 0, 0, "background");
        this.add(background);

        this.fishesContainer = new Phaser.GameObjects.Container(this.scene);
        this.add(this.fishesContainer);

        const letFrame = new Phaser.GameObjects.Image(this.scene, -366, 46, "texture_atlas_2", "column");
        this.add(letFrame);

        const rightFrame = new Phaser.GameObjects.Image(this.scene, 366, 46, "texture_atlas_2", "column");
        this.add(rightFrame);

        const upperFrame = new Phaser.GameObjects.Image(this.scene, 0, -406, "texture_atlas_2", "score_bar");
        this.add(upperFrame);

        const lowerFrame = new Phaser.GameObjects.Image(this.scene, 0, 480, "texture_atlas_2", "stone_bar");
        this.add(lowerFrame);

        const gridBackground = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_2", "grid");
        gridBackground.blendMode = Phaser.BlendModes.MULTIPLY;
        this.add(gridBackground);

        const coral = (this.scene as any).add.spine(0, 40, "corals");
        coral.scaleX = 1 / GameVars.scaleY;
        coral.scaleY = GameVars.scaleY;
        coral.skeleton.setToSetupPose();
        coral.setSkinByName("default"); 
        this.add(coral);
        
        coral.play("gui_animation", true);
        
        // init fishes pool
        this.fishesData = [];
        this.storedFishes = [];

        this.increasePoolSize(5);
    }

    public update(): void {

        let outOfScreenFishData: {sprite: Phaser.GameObjects.Sprite, y: number, a: number, v: number, dA: number, sign: number} = null;
        
        for (let i = 0; i < this.fishesData.length; i ++) {

            this.fishesData[i].a += this.fishesData[i].dA;

            this.fishesData[i].sprite.x += this.fishesData[i].sign * this.fishesData[i].v;
            this.fishesData[i].sprite.y = this.fishesData[i].y + 2 * Math.sin(this.fishesData[i].a);

            if (this.fishesData[i].sprite.x > GameConstants.GAME_WIDTH / 2 + 50 || this.fishesData[i].sprite.x < -GameConstants.GAME_WIDTH / 2 - 50) {
                outOfScreenFishData = this.fishesData[i];
            }
        }

        if (outOfScreenFishData) {

            const i = this.fishesData.indexOf(outOfScreenFishData);

            if (i !== -1) {
                this.fishesData.splice(i, 1);
            }
           
            this.storedFishes.push(outOfScreenFishData);
        }
  
        // EMITIR UN PEZ DE TANTO EN TANTO
        if (Math.random() > .9975) {
            this.getFish(Math.random() > .5 ? "left" : "right", BoardContainer.CELL_SIZE * Templok.Engine.GRID_SIZE / 2 * (1 - 2 * Math.random()));
        }
    }

    private emitFish(side: string, y: number): void {

        let n: number;
        let rnd = Math.random();

        if (rnd < .3) {
            n = 1;
        } else if (rnd < .66) {
            n = 2;
        } else {
            n = 3;
        }
        
        const fish = new Phaser.GameObjects.Sprite(this.scene, 0, 0, "texture_atlas_2", "fish_3_01");
        fish.anims.play("fish_" + n);
        this.scene.add.existing(fish);
        this.fishesContainer.add(fish);

        let sign: number;

        if (side === "left") {
            fish.x = -GameConstants.GAME_WIDTH / 2 - 50;
            sign = 1;
        } else {
            fish.x = GameConstants.GAME_WIDTH / 2 + 50;
            sign = -1;
        }

        fish.y = y;
        fish.scaleX = sign;

        this.storedFishes.push({sprite: fish, y: fish.y, a: 0, v: .75 + 1.05 * Math.random(), dA: .035 + .035 * Math.random(), sign: sign});
    }

    private getFish(side: string, y: number): void {

        if (this.storedFishes.length === 0) {
            this.increasePoolSize(5);
        }

        const fish = this.storedFishes.pop();
        // reset
        let sign: number;
        if (side === "left") {
            fish.sprite.x = -GameConstants.GAME_WIDTH / 2 - 50;
            sign = 1;
        } else {
            fish.sprite.x = GameConstants.GAME_WIDTH / 2 + 50;
            sign = -1;
        }
        fish.a = 0;
        fish.y = y;
        fish.sprite.scaleX = sign;
        this.fishesData.push({sprite: fish.sprite, y: fish.y, a: 0, v: .75 + 1.05 * Math.random(), dA: .035 + .035 * Math.random(), sign: sign});    
    } 

    private increasePoolSize(size: number): void {

        for (let i = 0; i < size; ++i) {
            this.emitFish(Math.random() > .5 ? "left" : "right", BoardContainer.CELL_SIZE * Templok.Engine.GRID_SIZE / 2 * (1 - 2 * Math.random()));
        }
    }
}
